// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function tapNone(opt, fn) {
  if (opt === undefined) {
    fn();
  }
  return opt;
}

function tapSome(opt, fn) {
  Stdlib_Option.forEach(opt, fn);
  return opt;
}

function toString(opt) {
  if (opt !== undefined) {
    return opt;
  } else {
    return "";
  }
}

function ofString(str) {
  if (str === "") {
    return;
  } else {
    return str;
  }
}

let filter = Stdlib_Option.filter;

let forEach = Stdlib_Option.forEach;

let getExn = Stdlib_Option.getExn;

let getOrThrow = Stdlib_Option.getOrThrow;

let mapOr = Stdlib_Option.mapOr;

let mapWithDefault = Stdlib_Option.mapWithDefault;

let map = Stdlib_Option.map;

let flatMap = Stdlib_Option.flatMap;

let getOr = Stdlib_Option.getOr;

let getWithDefault = Stdlib_Option.getWithDefault;

let orElse = Stdlib_Option.orElse;

let isSome = Stdlib_Option.isSome;

let isNone = Stdlib_Option.isNone;

let equal = Stdlib_Option.equal;

let compare = Stdlib_Option.compare;

let all = Stdlib_Option.all;

let all2 = Stdlib_Option.all2;

let all3 = Stdlib_Option.all3;

let all4 = Stdlib_Option.all4;

let all5 = Stdlib_Option.all5;

let all6 = Stdlib_Option.all6;

exports.filter = filter;
exports.forEach = forEach;
exports.getExn = getExn;
exports.getOrThrow = getOrThrow;
exports.mapOr = mapOr;
exports.mapWithDefault = mapWithDefault;
exports.map = map;
exports.flatMap = flatMap;
exports.getOr = getOr;
exports.getWithDefault = getWithDefault;
exports.orElse = orElse;
exports.isSome = isSome;
exports.isNone = isNone;
exports.equal = equal;
exports.compare = compare;
exports.all = all;
exports.all2 = all2;
exports.all3 = all3;
exports.all4 = all4;
exports.all5 = all5;
exports.all6 = all6;
exports.tapNone = tapNone;
exports.tapSome = tapSome;
exports.toString = toString;
exports.ofString = ofString;
/* No side effect */
